<div class="container h-full flex flex-col mx-auto px-4 md:px-6 pt-8 pb-4">
  <div class="flex items-center mb-4 min-h-10">
    <h2 class="text-2xl font-medium">Historie</h2>
  </div>

  <app-data-table-container class="rounded-lg">
    <table
      mat-table
      matSort
      matSortDirection="desc"
      matSortActive="startedAt"
      matSortDisableClear
      [matSortDisabled]="hasNoData()"
      (matSortChange)="handleSortChange($event)"
      [dataSource]="dataSource()"
    >
      <ng-container matColumnDef="name" sticky>
        <th mat-header-cell mat-sort-header="{{ sortingKeys.label }}" *matHeaderCellDef>Naam</th>
        <td mat-cell *matCellDef="let element">
          <span
            class="w-min max-w-40 truncate block"
            [matTooltip]="getInteractionName(element)"
            matTooltipPosition="after"
            >{{ getInteractionName(element) }}</span
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="version">
        <th mat-header-cell mat-sort-header="{{ sortingKeys.version }}" *matHeaderCellDef>Versie</th>
        <td mat-cell *matCellDef="let element">
          @if (element.isScmMedia) {
            <!-- Placeholder interaction — its version number says nothing. -->
            &mdash;
          } @else {
            <span
              class="bg-gray-300 text-gray-800 py-1 px-2 rounded-full text-xs font-medium"
            >
              v{{ element.interaction.version }}
            </span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell mat-sort-header="{{ sortingKeys.status }}" *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">
          <span
            class="text-xs font-medium px-3 py-2 rounded-full"
            [ngClass]="{
              'bg-gray-100 text-gray-950': element.status === 'expired',
              'bg-red-100 text-red-950': element.status === 'cancelled',
              'bg-orange-100 text-orange-950': element.status === 'pending',
              'bg-blue-100 text-blue-950': element.status === 'processing',
              'bg-green-100 text-green-950': element.status === 'completed',
            }"
          >
            {{ element.status | mapFrom: statusMap }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="closedReason">
        <th mat-header-cell *matHeaderCellDef>Reden voor sluiten</th>
        <td mat-cell *matCellDef="let element">
          <span
            class="text-xs font-medium px-3 py-2 rounded-full"
            [ngClass]="getClosedReasonBadge(element.closedReason)"
          >
            {{ getClosedReasonName(element.closedReason) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="startedAt">
        <th mat-header-cell mat-sort-header="{{ sortingKeys.startedAt }}" *matHeaderCellDef>Gestart op</th>
        <td mat-cell *matCellDef="let element">
          <span [matTooltip]="element.startedAt | date: 'MMMM dd, yyyy HH:mm:ss'">
            {{ element.startedAt | date: 'dd-MM-yyyy HH:mm:ss' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="endedAt">
        <th mat-header-cell mat-sort-header="{{ sortingKeys.endedAt }}" *matHeaderCellDef>Geëindigd op</th>
        <td mat-cell *matCellDef="let element">
          @if (element.endedAt) {
            <span [matTooltip]="element.endedAt | date: 'MMMM dd, yyyy HH:mm:ss'">
              {{ element.endedAt | date: 'dd-MM-yyyy HH:mm:ss' }}
            </span>
          } @else {
            Niet geëindigd
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="source">
        <th mat-header-cell mat-sort-header="{{ sortingKeys.source }}" *matHeaderCellDef>Bron</th>
        <td mat-cell *matCellDef="let element">
          @if (element.source === "scm") {
            Signalering
          } @else if (element.source === "scheduler") {
            Planning
          } @else {
            Onbekend
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="plannedAt">
        <th mat-header-cell mat-sort-header="{{ sortingKeys.plannedAt }}" *matHeaderCellDef>Gepland op</th>
        <td mat-cell *matCellDef="let element">
          @if (element.clientEvent) {
          <span [matTooltip]="element.clientEvent.startDate | date: 'MMMM dd, yyyy HH:mm:ss'">
            {{ element.clientEvent.startDate | date: 'dd-MM-yyyy, HH:mm' }}
          </span>
          &mdash;
          <span [matTooltip]="element.clientEvent.endDate | date: 'MMMM dd, yyyy HH:mm:ss'">
            {{ element.clientEvent.endDate | date: 'HH:mm' }}
          </span>
          } @else {
            Niet van toepassing
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element"></td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
        class="whitespace-nowrap"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="hover:!bg-gray-100 whitespace-nowrap"
      ></tr>

      <tr class="mat-mdc-row" *matNoDataRow>
        <td
          class="mat-mdc-cell mdc-data-table__cell !border-none"
          [colSpan]="displayedColumns.length"
        >
          Geen resultaten gevonden
        </td>
      </tr>
    </table>

    <mat-paginator
      class="border-t border-(--mat-table-row-item-outline-color)"
      [pageSizeOptions]="[25, 50, 100]"
      [pageSize]="pageSize()"
      (page)="handlePageChange($event)"
    ></mat-paginator>
  </app-data-table-container>
</div>
